import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface FrameSectionProps {
    title: string;
    className?: string;
}

const FrameSection: FC<PropsWithChildren<FrameSectionProps>> = ({ title, className, children }) => {
    return (
        <div className={twMerge('flex flex-col justify-start items-start', className)}>
            <h2 className="font-poppins font-medium text-sm leading-[14px] mb-6 uppercase">{title}</h2>
            {children}
        </div>
    );
};

export default FrameSection;
